import { submitSponsorRequest, submitMembershipRequest, submitAdhesionRequest } from './api';

export function sendWelcomeEmail(recipient) {
  console.log(`[DEV] Email de bienvenue envoyé à ${recipient}.`);
}

const ADMIN_RECIPIENTS = ['unisportduhautnkam@tutamail.com'];

export async function sendSponsorAcknowledgement({ company, email, phone, street, city, postalCode, country }) {
  try {
    await submitSponsorRequest({ company, email, phone, street, city, postalCode, country });
    alert(
      `Merci ${company || ''} ! Votre demande a bien été envoyée. Vous recevrez un e-mail de confirmation et un responsable vous contactera prochainement.`
    );
  } catch (error) {
    console.error("Impossible d'envoyer la demande de sponsoring", error);
    alert("Impossible d'envoyer votre demande de sponsoring pour le moment. Veuillez réessayer plus tard.");
    throw error;
  }
}

export async function sendMembershipAcknowledgement({
  civility,
  firstName,
  lastName,
  email,
  phone,
  membershipType,
  membershipLabel,
  street,
  city,
  postalCode,
  country,
  photo,
  photoName,
  photoType
}) {
  try {
    await submitMembershipRequest({
      civility,
      firstName,
      lastName,
      email,
      phone,
      membershipType,
      membershipLabel,
      street,
      city,
      postalCode,
      country,
      photo,
      photoName,
      photoType
    });
    alert(
      `Merci ${firstName} ! Un e-mail vous indiquera comment régler votre formule (${membershipLabel}) et envoyer la preuve de paiement.`
    );
  } catch (error) {
    console.error("Impossible d'envoyer la demande d'adhésion", error);
    alert("Impossible d'envoyer votre demande d'adhésion pour le moment. Veuillez réessayer plus tard.");
    throw error;
  }
}

export function notifyAdminsMembershipRequest(payload) {
  ADMIN_RECIPIENTS.forEach((adminEmail) => {
    console.log('[DEV] Notification admin adhésion', { adminEmail, payload });
  });
}

export async function sendAdhesionAcknowledgement({
  civility,
  firstName,
  lastName,
  email,
  phone,
  street,
  city,
  postalCode
}) {
  try {
    await submitAdhesionRequest({
      civility,
      firstName,
      lastName,
      email,
      phone,
      street,
      city,
      postalCode
    });
    alert(
      `Merci ${firstName} ! Un e-mail vous indiquera comment régler la cotisation adhérent (20 €) et envoyer la preuve de paiement.`
    );
  } catch (error) {
    console.error("Impossible d'envoyer la demande d'adhésion 20€", error);
    alert("Impossible d'envoyer votre demande d'adhésion pour le moment. Veuillez réessayer plus tard.");
    throw error;
  }
}

export function notifyAdminsAdhesionRequest(payload) {
  ADMIN_RECIPIENTS.forEach((adminEmail) => {
    console.log('[DEV] Notification admin adhérent', { adminEmail, payload });
  });
}
